import { onlineManager } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { queryKeys } from '@/queries/keys'
import {
  getBankAccountsQueryOptions,
  getPaymentMethodsQueryOptions,
} from '@/queries/query/payment'
import MyBookingPayment from '@/components/my-booking/Payment'

export const Route = createFileRoute('/my-booking/$id/payment')({
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getPaymentMethodsQueryOptions(params.id),
        ),
        context.queryClient.ensureQueryData(getBankAccountsQueryOptions()),
      ]
    }
    return [
      context.queryClient.getQueryData(queryKeys.payment.methods(params.id)),
      context.queryClient.getQueryData(queryKeys.payment.bankAccounts()),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <MyBookingPayment />
}
